<template>
  <div>
    <b-tabs pills card>
      <b-tab :title="$t('Main')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
              <b-form-invalid-feedback id="inputFeedback">
                {{ $t('Select accounting period') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.login" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim/>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ $t('Enter only english letters, numbers, at least 1 letter') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-select :options="listOfChargePolicy" v-model="dialupService.policy_id"/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :disabled="isEdit && dialupService.scheme_id > 0" :options="listOfCoefficientScheme" v-model="dialupService.scheme_id"  @change="coeffSchemeChanged"/>
            </b-form-group>
          <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input :disabled="dialupService.scheme_id > 0" type="number" v-model="dialupService.cost_coef"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
            <b-input-group>
              <b-form-input type="text" v-model="dialupService.charged_in_curr_period" disabled/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch  v-model="isCall">{{ $t('Callback is allowed') }}</b-form-checkbox>
            <b-form-checkbox switch  v-model="isRing">{{ $t('Ringdown is allowed') }}</b-form-checkbox>
            <b-form-checkbox-group name="checkbox-validation" :state="state">
              <b-form-invalid-feedback :state="state">{{ $t('Select ringdown or callback allowing') }}</b-form-invalid-feedback>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-tab>
      <b-tab :title="$t('Additional')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderStartDate"
            :isDisabled="isEdit"
            @onDateChanged="(unixDate) => {dialupService.start_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(dialupService.start_date ? dialupService.start_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderExpireDate"
            :isDisabled="infinityDate"
            @onDateChanged="(unixDate) => {dialupService.expire_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(dialupService.expire_date ? dialupService.expire_date : new Date()/1000 ).toDate())}"
            />
            <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="clear">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.house_comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.password"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Allowed CID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.allowed_cid"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Allowed CSID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="dialupService.allowed_csid"/>
          </b-form-group>
        </b-col>
      </b-tab>
       <b-tab :title="$t('Radius parameters')">
        <b-row>
          <b-col>
              <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
            <template v-slot:cell(actions)="row">
              <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
              <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
            </template>
          </b-table>
        </b-tab>
    </b-tabs>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" size="lg"/>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="dialupService.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="dialupService.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg" >
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormAccountinfPeriod,
    FormHouse,
    FormChargePolicies,
    FormCharged,
    FormRadiusAttributs
  },
  props: {
    listOfChargePolicy: null,
    listOfCoefficientScheme: null,
    tariffLinkId: 0,
    accountingPeriodId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      dialupServiceEdit: null,
      currentChargePolicy: null,
      isRing: false,
      isCall: false,
      isShowHouseUser: false,
      infinityDate: true,
      rerenderStartDate: 0,
      rerenderExpireDate: 0,
      dialupService: {
        'house_comment': '',
        'charged_in_curr_period': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'cost_coef': 100,
        'scheme_id': 0,
        'login': '',
        'password': '',
        'allowed_cid': '',
        'allowed_csid': '',
        'callback_enabled': 2,
        'slink_id': 0
      },
      radItemForEdit: null
    }
  },
  methods: {
    coeffSchemeChanged (schemeId) {
      if (schemeId === 0) {
        this.dialupService.cost_coef = 100
      } else {
        let newCostCoef = 100
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === schemeId) {
            for (let elIt of el.items) {
              if (elIt.delay === 0) {
                newCostCoef = elIt.coeff * 100
                break
              }
            }
            break
          }
        }
        this.dialupService.cost_coef = newCostCoef
      }
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    validation () {
      if (this.dialupService.login.length === 0) {
        return false
      }
      let strArray = this.dialupService.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.dialupService.login.length
    },
    showFormChargePolicies () {
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        if (this.dialupService.policy_id === el.policy_id) {
          this.currentChargePolicy = JSON.parse(JSON.stringify(el))
          this.$refs.detailChargePolicies.show()
        }
      }
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormHouse () {
      this.isShowHouseUser = true
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.isShowHouseUser = false
      this.$refs.houseUser.hide()
    },
    clear () {
      this.dialupService.house_id = 0
    },
    addCoefSchemeToSlink (newSlinkId) {
      if ((!this.isEdit && this.dialupService.scheme_id > 0) ||
     (this.dialupServiceEdit !== null &&
     this.dialupServiceEdit.coefficientschedulelink === undefined &&
     this.dialupService.scheme_id > 0)) {
        let coefSchedule = {items: []}
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === this.dialupService.scheme_id) {
            coefSchedule.items = el.items
          }
        }
        let responseCoefScheduleId = this.$store.dispatch('Users/CREATE_COEFFICIENT_SCHEDLE', coefSchedule)
        responseCoefScheduleId.then(responseCoefScheduleId => {
          let newCoefScheduleId = responseCoefScheduleId.data.coefficient_schedule_id
          let schedule = {
            scheme_id: this.dialupService.scheme_id,
            slink_id: Number(newSlinkId),
            schedule_id: Number(newCoefScheduleId),
            change_policy: 0
          }
          this.$store.dispatch('Users/CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE', schedule)
        })
      }
    },
    saveServiceLink () {
      if (this.isRing & this.isCall) {
        this.dialupService.callback_enabled = 1
      } else if (this.isCall) {
        this.dialupService.callback_enabled = 3
      } else if (this.isRing) {
        this.dialupService.callback_enabled = 0
      }
      if (this.dialupService.accounting_period_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
      } else if (this.dialupService.callback_enabled === 2) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select ringdown or callback allowing'), 'Error')
      } else if (this.validation()) {
        let tmpDialupService = JSON.parse(JSON.stringify(this.dialupService))
        tmpDialupService.expire_date = this.infinityDate ? 2000000000 : tmpDialupService.expire_date
        tmpDialupService.cost_coef = tmpDialupService.cost_coef / 100
        tmpDialupService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
        if (this.isEdit) {
          tmpDialupService.slink_id = this.currentService.service_link_id
        } else {
          tmpDialupService.account_id = this.selectedAccount
          tmpDialupService.service_id = this.currentService.service_id
          tmpDialupService.user_id = this.currentUser.user_id
        }
        let response = this.isEdit
          ? this.$store.dispatch('Users/UPDATE_DIALUP_SERVICE_LINK', tmpDialupService)
          : this.$store.dispatch('Users/CREATE_DIALUP_SERVICE_LINK', tmpDialupService)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            let radiusAttr = {
              'set_object_id': 0,
              'set_type': 10000,
              'attrs': []
            }
            radiusAttr.attrs = this.radiusAttrItems
            if (this.isEdit) {
              radiusAttr.set_object_id = this.currentService.service_link_id
            } else {
              radiusAttr.set_object_id = response.data.service_link_id
            }
            this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', radiusAttr)

            let newSlinkId = response.data.service_link_id ? response.data.service_link_id : this.currentService.service_link_id
            this.addCoefSchemeToSlink(newSlinkId)
            this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
            this.hideSelectService()
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('"Login" is incorrect'), 'Error')
      }
    }
  },
  beforeMount () {
    this.dialupService.scheme_id = this.currentService.scheme_id
    this.coeffSchemeChanged(this.currentService.scheme_id)
    if (this.isEdit) {
      this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SLINK', {slink_id: this.currentService.service_link_id})
      this.$store.dispatch('Users/GET_DIALUP_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.dialupServiceEdit = this.$store.getters['Users/DIALUP_SERVICE_LINK']
        this.dialupService.start_date = this.dialupServiceEdit.periodicservicelink.start_date
        this.dialupService.expire_date = this.dialupServiceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
        this.infinityDate = this.dialupServiceEdit.periodicservicelink.expire_date === 2000000000
        this.dialupService.cost_coef = this.dialupServiceEdit.periodicservicelink.cost_coef * 100
        this.dialupService.comment = this.dialupServiceEdit.periodicservicelink.comment
        this.dialupService.password = this.dialupServiceEdit.dialupServiceLink.password
        this.dialupService.login = this.dialupServiceEdit.dialupServiceLink.login
        this.dialupService.accounting_period_id = this.dialupServiceEdit.periodicservicelink.accounting_period_id
        this.dialupService.house_id = this.dialupServiceEdit.periodicservicelink.house_id
        this.dialupService.house_comment = this.dialupServiceEdit.periodicservicelink.house_comment
        this.dialupService.allowed_cid = this.dialupServiceEdit.dialupServiceLink.allowed_cid
        this.dialupService.allowed_csid = this.dialupServiceEdit.dialupServiceLink.allowed_csid
        this.dialupService.callback_enabled = this.dialupServiceEdit.dialupServiceLink.callback_enabled
        this.dialupService.policy_id = this.dialupServiceEdit.periodicservicelink.policy_id
        this.dialupService.scheme_id = this.dialupServiceEdit.scheme_id
        this.dialupService.charged_in_curr_period = Number.parseFloat(this.dialupServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
        switch (this.dialupService.callback_enabled) {
          case 1:
            this.isRing = true
            this.isCall = true
            break
          case 3:
            this.isRing = false
            this.isCall = true
            break
          case 0:
            this.isRing = true
            this.isCall = false
            break
        }
      })
      this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']))
      for (let el of this.radiusAttrItems) {
        el.value = el.attr_value
        if (el.tag && (el.vendor === 0)) {
          el.value = ':' + el.tag + ':' + el.attr_value
        }
        switch (el.attr_type) {
          case 1:
            el.attrType = this.$i18n.t('Number')
            break
          case 2:
            el.attrType = this.$i18n.t('String')
            break
          case 3:
            el.attrType = 'IP'
            break
          case 4:
            el.attrType = this.$i18n.t('Binary')
            break
        }
      }
    } else {
      this.dialupService.policy_id = this.currentService.policy_id
      this.dialupService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  },
  computed: {
    radAttrsSlink () {
      return this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']
    },
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.dialupService.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.dialupService.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    userHouse () {
      let userHouse = ''
      if (this.dialupService.house_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.dialupService.house_id) {
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            userHouse += '(' + el.house_id + ')'
            break
          }
        }
      }
      return userHouse
    },
    inputLoginState () {
      return this.validation()
    },
    state () {
      return this.isCall || this.isRing
    }
  },
  watch: {
    radAttrsSlink: function (items) {
      this.radiusAttrItems = items
      for (let el of this.radiusAttrItems) {
        el.value = el.attr_value
        if (el.tag && (el.vendor === 0)) {
          el.value = ':' + el.tag + ':' + el.attr_value
        }
        switch (el.attr_type) {
          case 1:
            el.attrType = this.$i18n.t('Number')
            break
          case 2:
            el.attrType = this.$i18n.t('String')
            break
          case 3:
            el.attrType = 'IP'
            break
          case 4:
            el.attrType = this.$i18n.t('Binary')
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formDialup.vue